import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Menu, MenuItem, IconButton } from '@material-ui/core';
import { Settings as SettingsIcon } from '@material-ui/icons';
import Logo from '../../../images/logo.png';
import { push } from '../../../core/router/actions';

class Header extends React.Component {
  state = {
    anchorEl: null,
  };

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { authenticated, signOut, email } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);

    return (
      <header className="header">
        <div className="g-row">
          <div className="g-col">
            <Link to="/">
              <h1 className="header__title">
                <img src={Logo} height={40} alt="謎解きビンゴ" />
              </h1>
            </Link>

            {authenticated ? (
              <ul className="header__actions">
                <li className="userInfo">
                  <span className="username">{email}</span>
                </li>
                <li>
                  <IconButton
                    aria-owns={open ? 'menu-appbar' : null}
                    aria-haspopup="true"
                    onClick={this.handleMenu}
                    color="inherit"
                    aria-label="Setting"
                    className="header--menu"
                  >
                    <SettingsIcon />
                  </IconButton>
                  <Menu
                    anchorEl={anchorEl}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    open={open}
                    onClose={this.handleClose}
                  >
                    {authenticated ? (
                      <MenuItem
                        onClick={() => {
                          this.props.push('/setting');
                          this.handleClose();
                        }}
                      >
                        Settings
                      </MenuItem>
                    ) : null}
                    {authenticated ? (
                      <MenuItem
                        onClick={() => {
                          this.handleClose();
                          signOut();
                        }}
                      >
                        Sign out
                      </MenuItem>
                    ) : null}
                  </Menu>
                </li>
              </ul>
            ) : null}
          </div>
        </div>
      </header>
    );
  }
}

Header.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  email: PropTypes.string.isRequired,
  signOut: PropTypes.func.isRequired,
  push: PropTypes.func,
};

const mapDispatchToProps = {
  push,
};

export default connect(null, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/views/components/header/index.js